import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { TextField, FakeText, Typography } from '@totalsoft/rocket-ui';
import { get, set } from '@totalsoft/change-tracking-react';
import { emptyString } from 'constants/defaultValues';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { valueOrDefault } from 'utils/functions';
import defaultAssetImage from 'assets/img/Car2.png';
import { onTextBoxChange } from 'utils/propertyChangeAdapters';
import { AssetImageContainer, OfferDataImage } from '../PolicyStyles';

const AssetOfferDataCard = ({
  insuranceTypeCode,
  rcaInsuranceTypeCode,
  cascoInsuranceTypeCode,
  assetLens,
  category,
  subcategory,
  showEditableFields,
  disabled,
  readOnly,
  validation,
  loading
}) => {
  const { t } = useTranslation();

  const lg = insuranceTypeCode === cascoInsuranceTypeCode ? 12 : 6;

  return (
    <Grid container>
      <Grid item container xs={12} md={9} spacing={2}>
        {loading && <FakeText lines={2} />}
        {!loading && (
          <>
            <Grid item xs={12}>
              <Typography fontWeight='bold' variant='subtitle1'>
                {t('Offer.Edit.OfferData.Asset.Title')}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={lg}>
              <strong> {t('Offer.Edit.OfferData.Asset.Description')}</strong>: <span>{assetLens.description |> get || '-'}</span>
            </Grid>
            <Grid item xs={12} lg={lg}>
              <strong> {t('Offer.Edit.OfferData.Asset.ChassisNumber')}</strong>: <span>{(assetLens.chassisNumber |> get) || '-'}</span>
            </Grid>
            <Grid item xs={12} lg={lg}>
              <strong> {t('Offer.Edit.OfferData.Asset.Category')}</strong>: <span>{category || '-'}</span>
            </Grid>
            {insuranceTypeCode === rcaInsuranceTypeCode ? (
              <>
                <Grid item xs={12} lg={6}>
                  <strong> {t('Offer.Edit.OfferData.Asset.IdentityCardSeries')}</strong>:{' '}
                  <span>{(assetLens.identityCardSeries |> get) || '-'}</span>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <strong> {t('Offer.Edit.OfferData.Asset.Subcategory')}</strong>: <span>{subcategory || '-'}</span>
                </Grid>
                <Grid item xs={12} lg={6}></Grid>
                {showEditableFields && (
                  <Grid item xs={6} md={3} lg={2}>
                    <TextField
                      id='IdentityCardSeries'
                      fullWidth={true}
                      required={true}
                      label={t('Offer.Edit.OfferData.Asset.IdentityCardSeries')}
                      value={assetLens.identityCardSeries |> get |> valueOrDefault(emptyString)}
                      onChange={onTextBoxChange(assetLens.identityCardSeries |> set, {
                        uppercase: true,
                        rejectWhitespace: true
                      })}
                      disabled={disabled || readOnly('PolicyOfferData.Asset.IdentityCardSeries')}
                      error={!isValid(validation.asset.identityCardSeries)}
                      helperText={getErrors(validation.asset.identityCardSeries)}
                      inputProps={{
                        maxLength: 7
                      }}
                    />
                  </Grid>
                )}
              </>
            ) : (
              <></>
            )}
          </>
        )}
        <Grid item xs={12} />
      </Grid>
      <AssetImageContainer item xs={12} md={3}>
        <OfferDataImage src={(assetLens.imageUrl |> get) || defaultAssetImage} alt='...' />
      </AssetImageContainer>
    </Grid>
  );
};

AssetOfferDataCard.propTypes = {
  insuranceTypeCode: PropTypes.string,
  rcaInsuranceTypeCode: PropTypes.string,
  cascoInsuranceTypeCode: PropTypes.string,
  assetLens: PropTypes.object,
  category: PropTypes.string,
  subcategory: PropTypes.string,
  showEditableFields: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.func,
  validation: PropTypes.object,
  loading: PropTypes.bool
};

export default AssetOfferDataCard;
